import * as React from 'react';
import { FavouriteLayoutComponentProps } from './types';
import { PresentationType } from './constants';
import { ChartFavourite } from './chart-favourite';
import { TileViewFavourite, TableViewFavourite } from './data-layout';
import styles from './favourite-layout-component-factory.scss';

export const isPresentationTypeSupported = (presentationType: number) => {

  return presentationType === PresentationType.Table ||
    presentationType === PresentationType.Tile ||
    presentationType === PresentationType.Highcharts;
};

const getComponent = (presentationType: number):
  typeof TableViewFavourite | typeof TileViewFavourite | typeof ChartFavourite => {

  if (!isPresentationTypeSupported(presentationType)) {
    return undefined;
  }

  if (presentationType === PresentationType.Highcharts) {
    return ChartFavourite;
  }

  if (presentationType === PresentationType.Table) {
    return TableViewFavourite;
  }

  if (presentationType === PresentationType.Tile) {
    return TileViewFavourite;
  }

  return undefined;
};

export const createFavouriteComponent = (presentationType: number, props: FavouriteLayoutComponentProps, wrapperClassName: string) => {

  const Component = getComponent(presentationType);
  if (!Component) {
    return (<div>{props.translation.favourite_not_present_type_favourite}</div>);
  }

  if (props.favouriteDataModel && props.favouriteDataModel.rows && props.favouriteDataModel.rows.length === 0) {
    return <div className={styles.noRows}>{props.translation.no_search_result}</div>;
  }

  let contentHeightStyle:any;
  const layoutAttributes = {...props.layoutAttributes};
  if (props.height) {

    if (layoutAttributes) {
      layoutAttributes['HighchartsStyle.userDefinedHeightEnabled'] = true;
      layoutAttributes['Highcharts.chart.height'] = props.height;
      layoutAttributes['HighchartsStyle.userDefinedHeightValue'] = props.height;
    } else {
      contentHeightStyle.overflow = 'auto';
      contentHeightStyle = {maxHeight: props.height+1};
    }
  }

  return <div key={props.height} className={wrapperClassName} style={contentHeightStyle}>
    <Component {...{...props, layoutAttributes}} />
  </div>;
};
